import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {environment} from '../../../../environments/environment';
import { MadAuthService } from '../../mad-auth/mad-auth.service';
import {HttpUtilsService, QueryParamsModel} from '../../_base/crud';
import {Appendix} from '../_models/appendix.model';
import { SubdomainService } from '../../_base/subdomain.service';



@Injectable()
export class AppendicesService {
    API_URL = environment.baseApiUrl + `api/${this.subDomainService.subDomain}/appendices`;

    constructor(private http: HttpClient, private authService: MadAuthService, private httpUtils: HttpUtilsService, private subDomainService: SubdomainService) {
    }

    // Appendices
    getAll(): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL, {headers: httpHeaders});
    }

    getAllMultimedia(): Observable<any> {
        return this.http.get<any>(
            `${environment.baseApiUrl}api/${this.subDomainService.subDomain}/multimedia/appendices`
        );
    }


    find(queryParams: QueryParamsModel, catId: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        const httpParams = this.httpUtils.getFindHTTPParams(queryParams);

        const url = environment.baseApiUrl + `api/${this.subDomainService.subDomain}/appendix-categories/` + catId + '/appendices';
        return this.http.get<any>(url, {
            headers: httpHeaders,
            params: httpParams
        });
    }

    getById(appendixId: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + `/${appendixId}`, {headers: httpHeaders});
    }

    // CREATE =>  POST: add a new appendix to the server
    create(appendix: Appendix, fileList: any[]): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        const body = {appendix, fileList};

        return this.http.post(this.API_URL, body, {headers: httpHeaders});
    }

    // UPDATE => PUT: update the appendix on the server
    update(appendix: Appendix, fileList: any[]): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        const body = {appendix, fileList};
        return this.http.put(this.API_URL + `/${appendix.id}`, body, {headers: httpHeaders});
    }

    // DELETE => delete the appendix from the server
    delete(appendixId: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        const url = `${this.API_URL}/${appendixId}`;
        return this.http.delete(url, {headers: httpHeaders});
    }


    // TRASH (User)
    getTrashed(catId: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + '/' + catId + '/trash', {headers: httpHeaders});
    }

    flushTrash(catId: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + '/' + catId + '/trash/flush', {headers: httpHeaders});
    }

    deleteFromTrash(agencyId: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.delete<any>(this.API_URL + `/trash/${agencyId}`, {headers: httpHeaders});
    }

    // TRASH (Admin)
    getAdminTrashed(catId: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + '/' + catId + `/admin/trash`, {headers: httpHeaders});
    }

    // delete from admin trash
    deleteFromAdminTrash(agencyId: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.delete<any>(this.API_URL + `/admin/trash/${agencyId}`, {headers: httpHeaders});
    }

    // restore from trash
    restoreFromTrash(id: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + `/trash/${id}`, {headers: httpHeaders});
    }

    /*
     * Handle Http operation that failed.
     * Let the app continue.
    *
    * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: any) {
        return (error: any): Observable<any> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // Let the app keep running by returning an empty result.
            return of(result);
        };
    }
}
